import moment from "moment";
import { ButtonGroup, Paper, Table as TableBs } from "@mui/material";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import { getTime } from "helpers/GetTime";
import { meetingType } from "./CreateMeeting/Create";
import StatusLayout from "components/Status";
import MeetingDetailsDialog from "../../helpers/MeetingDetailsDialog";
import axios from "axios";
import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import FormDialog from "../../helpers/FormDialog";


const Table = (props) => {
  const {
    setSelected,
    selected,
    GetAllMeetings,
    notification,
    MarkAsRead,
    type,
    systemSettings,
  } = props;
  let history = useHistory();
  const mainBackground = systemSettings?.mainBackground;

  const [meetings, setMeetings] = React.useState([]);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedMeeting, setSelectedMeeting] = React.useState(null);
  const [resource, setResource] = React.useState([]);
  const [addMeeting, setAddMeeting] = React.useState(false);
  // const [meeting, setMeeting] = React.useState([]);

  const handleOpenModal = (meetingDetails) => {
    setSelectedMeeting(meetingDetails);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedMeeting(null);
    setModalOpen(false);
  };

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const resp = await axios.get(`/api/resource/listAll`);
        if (resp.status === 200) {
          setResource(resp.data.data);
        }
      } catch (error) {
      }
    };
    fetchResources();
  }, []);


  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "venue",
      label: "Venue",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (data, index) =>{
          if(meetings[index]?.Room === null || meetings[index]?.roomId === null){
            return "Virtual";
          }
          return meetings[index]?.Room?.name ?? meetings[index]?.venue
        }
      },
    },
    {
      name: "type",
      label: "Type",
      // options: {
      //   filter: true,
      //   sort: true,
      //   customBodyRender: (v) =>
      //     meetingType?.find((item) => item.value === v)?.label,
      // },
    },
    {
      name: "start",
      label: "Start Time",
      // options: {
      //   filter: true,
      //   sort: true,
      //   customBodyRender: (value) => getTime(value) ?? "",
      // },
      options: {
        customBodyRender: (value) =>
          value ? moment(value).utc().format("YYYY-MM-DD HH:mm") : "N/A",
      },
    },
    {
      name: "end",
      label: "End Time",
      // options: {
      //   filter: true,
      //   sort: true,
      //   customBodyRender: (value) => getTime(value) ?? "",
      // },
      options: {
        customBodyRender: (value) =>
          value ? moment(value).utc().format("YYYY-MM-DD HH:mm") : "N/A",
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => <StatusLayout status={status} />,
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (id) => {
          let detail =
            notification?.filter(
              (notif) =>
                notif?.content?.id === id && notif?.content?.type === "meeting"
            ) ?? [];
          const meetingDetails = meetings.find((meeting) => meeting.id === id);

          return (
            <Button
              style={{ color: mainBackground }}
              onClick={() => {
                if (detail && detail[0]?.id) {
                  MarkAsRead(detail[0]?.id);
                }
                history.push(`/admin/meeting/details/${id}`);
                // handleOpenModal(meetingDetails);
              }}
            >
              <i className="fa fa-info-circle fa-md me-1" /> Details{" "}
              {detail[0]?.content?.id === id ? (
                <span className="badge bg-green-400 rounded-pill ">
                  {"NEW"}
                </span>
              ) : null}
            </Button>
          );
        },
      },
    },
  ];

  return (

    <div>

      <FormDialog
        maxWidth={'md'}
        col={6}
        open={addMeeting > 0}
        onSuccess={() => {
          window.location.reload();
        }}
        setOpen={setAddMeeting}
        title={"Schedule New Meeting"}
        fields={[
          {
            name: "start",
            label: "Start Time",
            type: "datetime-local",
            value: moment().format("YYYY-MM-DDTHH:mm"),
            required: true,
          },
          {
            name: "end",
            label: "End Time",
            type: "datetime-local",
            value: moment().add(1, 'hours').format("YYYY-MM-DDTHH:mm"),
            required: true,
          },
          {
            name: "type",
            label: "Type",
            type: "select",
            // options: getMeetingTypes(loggedUser).map((item) => ({
            //   value: item.value,
            //   label: item.label,
            // })),
            required: true,
          },
          {
            name: "venue",
            label: "Venue",
            type: "text",
            condition: (info) => info?.type === "project",
            required: true,
          },
          {
            name: "roomId",
            label: "Available Rooms",
            type: "select",
            // options: rooms?.map((item) => ({
            //   value: item.id,
            //   label: item.name,
            // })),
            condition: (info) => info?.type !== "project",
          },
          {
            name: "name",
            label: "Meeting Name",
            type: "text",
            required: true,
          },
          {
            name: "reminder",
            label: "Reminder",
            type: "select",
            options: [
              { value: 15, label: "15 min before" },
              { value: 30, label: "30 min before" },
              { value: 60, label: "1 hour before" },
              { value: 1, label: "1 day before" },
            ],
            required: true,
          },
          {
            name: "projectId",
            label: "Projects",
            type: "select",
            // options: projects?.map((item) => ({
            //   value: item.id,
            //   label: item.name,
            // })),
            condition: (info) => info?.type === "project",
            required: true,
          },
          {
            name: "agenda",
            label: "Agenda",
            type: "editor",
            col: 12,
            // value: meeting?.agenda ?? "",
            // required: true,
          },
          // {
          //   name: "participants",
          //   label: "Participants",
          //   type: "custom",
          //   render: () => (
          //     <TableContainer>
          //       <Table size={"small"}>
          //         <TableHead>
          //           <TableRow>
          //             <TableCell>#</TableCell>
          //             {participants?.map((v) => (
          //               <TableCell className="text-capitalize">{v.label}</TableCell>
          //             ))}
          //             <TableCell>Action</TableCell>
          //           </TableRow>
          //         </TableHead>
          //         <TableBody>
          //           {owners.map((owner, index) => (
          //             <StyledTableRow key={index}>
          //               <TableCell>#{index + 1}</TableCell>
          //               {owner.map((v) => (
          //                 <TableCell>{v.value}</TableCell>
          //               ))}
          //               <TableCell>
          //                 <CustomizedMenus
          //                   owner={owners[index]}
          //                   setIndex={setIndex}
          //                   index={index}
          //                   setEditObject={setEditObject}
          //                   onDelete={() => {
          //                     setOwners([
          //                       ...owners.slice(0, index),
          //                       ...owners.slice(index + 1),
          //                     ]);
          //                   }}
          //                   setModelOpen={setOther}
          //                 />
          //               </TableCell>
          //             </StyledTableRow>
          //           ))}
          //         </TableBody>
          //       </Table>
          //     </TableContainer>
          //   ),
          // },
        ]}
      />
      <DatatableComponent
        search={false}
        viewColumns={false}
        searchfield={true}
        onCalendarChange={false}
        onMinutes={true}
        onMeeting={true}
        title={
          <ButtonGroup
            variant="outlined"
            color={"success"}
            size={"small"}
            aria-label="outlined button group"
            style={{ gap: "3px" }}
          >
            {["All", "scheduled", "completed", "canceled"].map((title, key) => (
              <Button
                key={key}
                type="button"
                style={{
                  backgroundColor: selected === title ? mainBackground : "",
                  color: selected === title ? "white" : "black",
                  fontWeight: "light",

                  padding: "10px 20px",
                  borderWidth: "1px",
                  borderColor: "#D5D9DD",
                  borderStyle: "solid",
                  height: "40px",
                  borderRadius: "10px",
                }}
                onClick={() => {
                  setSelected(title);
                  GetAllMeetings(title);
                }}
              >
                {title}
              </Button>
            ))}
          </ButtonGroup>
        }
        processData={(data) => {
          setMeetings(data.data);
          return data;
        }}
        columns={columns}
        url={
          type === "minutes"
            ? `/api/meeting/datatable/?status=${selected}&minutes=1`
            : type === "invited-in"
              ? `/api/meeting/invited-in/datatable/?status=${selected}`
              : `/api/meeting/datatable/?status=${selected}`
        }
        useMeetingUrl={true}
      // onAddNew={() => {
      //   history.push("/admin/schedule-meeting");
      // }}

      // onAddNew={() => setAddMeeting(true)}
      />

      <MeetingDetailsDialog
        open={modalOpen}
        onClose={handleCloseModal}
        meetingDetails={selectedMeeting}
        resource={resource}

      />

      {/* <FormDialog open={addMeeting} onClose={() => setAddMeeting(false)} /> */}
    </div>
  );
};




const List = (props) => {
  return (
    <>
      <Table {...props} />
    </>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(List);
